export default class AsideErSidebar {

    constructor($view) {
        this.$view = $view;
        this.$toggleSidebar = $('.js-toggle-sidebar');
        this.$backdrop = this.$view.find('.js-backdrop');
        this.bind();
    }

    bind() {
        let self = this;

        this.$toggleSidebar.on('click', (e) => {
            self.$view.toggleClass('opened');
            self.$toggleSidebar.toggleClass('opened');
        });

        this.$view.on('click', '.js-has-children > a', (e) => {
           $(e.currentTarget).closest('.js-has-children').toggleClass('opened');
        });
    }


}
